import { arrayUnion, doc, updateDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase";

/** Function that updates a user's array of roundsPlayed
  @param {String} id
  @param {String} game
  @param {String} level
  @param {Object} gameStats
  @param {String} answer
  *@returns returns void.
  */
export const saveUserRound = async (id, game, level, gameStats, answer) => {
  const { isCorrect, score } = gameStats;

  const docRef = doc(db, "users", id);

  await updateDoc(docRef, {
    roundsPlayed: arrayUnion({
      correct: isCorrect,
      gameId: game,
      phonic: answer,
      level: level,
      roundTime: Timestamp.fromDate(new Date()).toDate(),
      score: score,
    }),
  });
};

export const saveUserStats = async (
  id,
  energyLevel,
  fuelLevel,
  healthLevel
) => {
  const docRef = doc(db, "users", id);
  await updateDoc(docRef, {
    energyLevel: energyLevel,
    fuelLevel: fuelLevel,
    healthLevel: healthLevel,
  });
};

export const resetEnergyLevel = async (id) => {
  const docRef = doc(db, "users", id);
  await updateDoc(docRef, {
    energyLevel: 100,
  });
};
